import React, { FC, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';

interface ReportModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: (file_type: 'excel' | 'csv' | 'pdf') => void;
}


const ReportModal: FC<ReportModalProps> = ({
                                               show,
                                               onHide,
                                               onConfirm
                                           }) => {
    const [fileType, setFileType] = useState({
        excel: true,
        csv: false,
        pdf: false,
    });

    const handleOnHide = () => {
        onHide();
    };

    const handleOnCLick = () => {
        if (fileType.excel)
            onConfirm('excel');
        else if (fileType.csv)
            onConfirm('csv');
        else if (fileType.pdf)
            onConfirm('pdf');
        else
            onConfirm('excel');
    };

    const handleChange = (e: any) => {
        const update = {
            excel: false,
            csv: false,
            pdf: false,
        };
        update[e.target.id as 'excel' | 'csv' | 'pdf'] = e.target.checked;
        setFileType(update);
    };

    return <Modal show={show} onHide={handleOnHide} centered size={'lg'}>
        <Modal.Header style={{
            display: 'flex',
            justifyContent: 'left',
        }}>
            <Modal.Title>
                <h4 className="text-center text-mof-primary m-0">
                    ดาวน์โหลดรายงาน
                </h4>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="row">
                <div className="col-12">
                    <p>กรุณาเลือกประเภทของไฟล์</p>
                </div>
                <div className="col-12">
                    <div className="form-check">
                        <input className="form-check-input pointer no-validate" type="radio"
                               defaultChecked={fileType.excel}
                               onChange={handleChange}
                               name="fileType"
                               id="excel"/>
                        <label className="form-check-label pointer" htmlFor="excel">
                            Excel
                        </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input pointer no-validate" type="radio"
                               defaultChecked={fileType.csv}
                               onChange={handleChange}
                               name="fileType"
                               id="csv"/>
                        <label className="form-check-label pointer" htmlFor="csv">
                            Csv
                        </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input pointer no-validate" type="radio"
                               defaultChecked={fileType.pdf}
                               onChange={handleChange}
                               name="fileType"
                               id="pdf"/>
                        <label className="form-check-label pointer" htmlFor="pdf">
                            Pdf
                        </label>
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer style={{
            display: 'flex',
            justifyContent: 'right',
        }}>
            <Button variant="secondary" className="btn-action" onClick={handleOnHide}>
                <FontAwesomeIcon icon={faCaretLeft} className="me-2"/>
                ย้อนกลับ
            </Button>
            <Button variant="primary" className="btn-action" onClick={handleOnCLick}>
                ดาวน์โหลด
            </Button>
        </Modal.Footer>
    </Modal>;
};

export default ReportModal;